exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".owlShopColorPicker{padding-left:30px;padding-right:30px;border-top:1px solid #eee;padding-top:10px;margin-top:10px}.owlShopColorPicker .swatch{position:relative;display:inline-block;border-radius:8px;width:25px;height:25px;margin-right:10px;cursor:pointer}.owlShopColorPicker .swatch:hover{opacity:.7}.owlShopColorPicker .swatch.active{box-shadow:0 0 2px #aaa solid}.owlShopColorPicker .swatch .glyphicon{position:absolute;top:5px;left:11px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/avatars/owl_shop_color_picker.scss
// module id = 1247
// module chunks = 0